import React from 'react';
import styles from '../../styles/test/TestStyles.module.css';

const TestProgress = ({ current, total }) => {
  // Calculate progress percentage
  const progressPercentage = (current / total) * 100;
  
  return (
    <div className={styles.progreso}>
      <span className={styles.progresoText}>
        Pregunta <strong>{current}</strong> de <strong>{total}</strong>
      </span>
      
      <div className={styles.progressBarContainer}>
        <div
          className={styles.progressBar}
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
    </div>
  );
};

export default TestProgress;